import Axios from "../config/axios-v1-config";

// Gestión de "equipo" del comercio (colegas de portal de la misma company).
// Rutas homeadas en microservice-users bajo /users/team/*; el companyId lo
// deriva el backend del JWT (no se manda desde acá).

export const getTeamUsers = async () => {
  try {
    const response = await Axios.get("/users/team");
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al obtener usuarios" } };
  }
};

export const createTeamUser = async (userData) => {
  try {
    const response = await Axios.post("/users/team", userData);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al crear usuario" } };
  }
};

export const activateTeamUser = async (userId) => {
  try {
    const response = await Axios.patch(`/users/team/${userId}/activate`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al activar usuario" } };
  }
};

export const deactivateTeamUser = async (userId) => {
  try {
    const response = await Axios.patch(`/users/team/${userId}/deactivate`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al desactivar usuario" } };
  }
};

export const resendTeamInvite = async (userId) => {
  try {
    const response = await Axios.post(`/users/team/${userId}/resend`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Error al reenviar la invitación" } };
  }
};

/**
 * Resuelve los correos de la columna "Correo del vendedor" de la planilla a
 * usuarios del comercio. Sólo lo puede llamar un supervisor de ventas.
 *
 * Es un aviso TEMPRANO para poder señalar la fila mala antes de enviar el lote:
 * la resolución que vale es la que hace microservice-packages al crear, con el
 * comercio del token. Devuelve `hasCompleteBankData` como booleano, nunca la
 * cuenta bancaria.
 */
export const resolveSellerEmails = async (emails) => {
  try {
    const response = await Axios.post("/users/team/resolve-seller-emails", { emails });
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "No se pudieron verificar los correos" } };
  }
};

// Endpoints públicos (el invitado está deslogueado → sin token de sesión).

export const verifyTeamInvite = async (token) => {
  try {
    const response = await Axios.get(`/users/team/invite/${token}`);
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "Invitación inválida" } };
  }
};

export const acceptTeamInvite = async ({ token, password }) => {
  try {
    const response = await Axios.post("/users/team/invite/accept", { token, password });
    return { data: response.data, error: null };
  } catch (error) {
    return { data: null, error: error.response?.data || { message: "No se pudo aceptar la invitación" } };
  }
};
